import type { Series } from '../visualizations/shared/pivot.js';
import { formatUnitValue } from './format-unit-value.js';

/**
 * Creates a value formatter that looks up the correct dataset by index.
 * Recharts passes datasetIndex in tooltip/tick callbacks, fixing the
 * multi-series bug where all series used the first dataset's unit.
 */
export function createChartFormatter(
  datasets: Series[]
): (value: number, datasetIndex?: number) => string {
  return (value, datasetIndex = 0) => {
    const ds = datasets[datasetIndex];
    if (!ds) return value.toLocaleString();
    return formatUnitValue(value, ds.type, ds.currency, ds.unit);
  };
}
